import * as React from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import CyMonteCarlo from "../../../components/Charts/CyMonteCarlo";
import CurrencyNumber from "../../../components/UI/CurrencyNumber";

const StrategyMonteCarloChart = (props) => {
  const {
    portfolio,
    startDate
  } = props;
  const { metadata, cprRecommendation } = portfolio;

  return (
    <section
      className={"content"}
      data-toc={"Portfolio Projection Monte Carlo Simulation"}
    >
      <Grid container={true}>
        <Grid item xs={12}>
          <Typography variant="h4">
            Cy Portfolio Projection
          </Typography>
          <Typography variant="h6" gutterBottom={true}>
            Investment Amount{" "}
            <CurrencyNumber value={metadata.initialInvestment} />
          </Typography>
        </Grid>
        <Grid item={true}>
          <CyMonteCarlo
            initialInvestment={metadata.initialInvestment}
            mean={parseFloat(cprRecommendation.summary.recommendationSummary.AnnualizedReturn)}
            sd={parseFloat(cprRecommendation.summary.recommendationSummary.AnnualizedStandardDeviation)}
            forPrinting={true}
            startDate={startDate}
          />
        </Grid>
      </Grid>
    </section>
  );
};


export default StrategyMonteCarloChart;



// WEBPACK FOOTER //
// ./src/containers/SummaryPDF/components/StrategyMonteCarloChart.jsx